<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Custom Clearance Export Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto"></b-navbar-nav>
        </b-navbar>

        <!-- <div>
          <b-nav tabs>
            <b-nav-item disabled></b-nav-item>
            <b-nav-item
              :active="filtrActive == 0 ? true : false"
              @click="viewFFExportFCL('0', '0', '1', '1')"
              >All</b-nav-item
            >
           
            <b-nav-item
              :active="filtrActive == 2 ? true : false"
              @click="viewFFExportFCL('2', '0', '1', '1')"
              >Pending LEO Date
              <b-badge variant="light">{{ this.pending_LEO_Count }}</b-badge>
            </b-nav-item>
            <b-nav-item
              :active="filtrActive == 3 ? true : false"
              @click="viewFFExportFCL('3', '0', '1', '1')"
              >Pending Handover Date
              <b-badge variant="light">{{
                this.pending_handover_Count
              }}</b-badge>
            </b-nav-item>
          </b-nav>
        </div> -->
        <div>
          <!-- <div >
    <md-layout md-gutter class="gutr">
            <md-layout md-flex="70"></md-layout>
 <md-layout md-flex="30">
                    <label for="containerTypeId">Billing Status</label>
                    <model-list-select
                      @input="viewFFExportFCL('0', '0', '1', '1');"
                      :list="invoiceStatusList"
                  v-model="billingFilter"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select Status"
                    ></model-list-select>
    </md-layout>
    </md-layout>

</div> -->

          <div>
            <div class="row mt-3">
              <div class="col-md-7">
                <b-form-group>
                  <b-input-group>
                    <b-form-input
                      :formatter="capitalizeAll"
                      v-model="filter"
                      placeholder="Search Client /SB No./Shipper Invoice No."
                      @input="debounceSearch"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <model-list-select
                  @input="viewFFExportFCL('0', '0', '1', '1')"
                  :list="invoiceStatusList"
                  v-model="billingFilter"
                  option-value="inv"
                  option-text="int"
                  placeholder="Select Status"
                ></model-list-select>
              </div>
              <div class="col-md-2">
                <model-list-select
                  @input="viewFFExportFCL('Normal', '0', '0', '1', '1')"
                  :list="dateStatusList"
                  v-model="dateStatusFilter"
                  option-value="inv"
                  option-text="int"
                  placeholder="Select Date Filter"
                ></model-list-select>
              </div>
              <div>
                <h5 class="text-muted pull-right mt-2 ml-3">
                  <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                </h5>
              </div>
            </div>
          </div>
          <div style="margin-top: 15px" class="tableMain table-responsive mt-4">
            <b-table
              show-empty
              stacked="md"
              responsive
              :items="AirImportData"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="seenExec" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="ccImportSeries" slot-scope="row1">
                <b-badge v-if="row1.item.seenExec == '0'" variant="danger"
                  >New
                  <br />
                </b-badge>
                <b
                  :style="row1.item.seenExec == '0' ? 'color:red' : 'color:black'"
                  @click="
                    row1.item.is_locked == '1' &&
                    (row1.item.finalBillingCompleted == 1 ||
                      row1.item.locked_counter > 0) &&
                    $sessionsStorage.get('designation') != 'Admin' &&
                    $sessionsStorage.get('nameUser') != 'Bhavneesh'
                      ? ''
                      : viewExportAirPage(row1.item)
                  "
                  class="showMoreData"
                  >{{ row1.item.ccImportSeries }}</b
                >
                <br />
                <span>Assignment Dt.: {{ row1.item.dateAssignment | moment }}</span>

                <br />
                <span>Raised From : {{ row1.item.raisedFrom }}</span>
                <br />
                <span>By : {{ row1.item.raisedBy }}</span>
                <br />
                <h7 class="mt-2" v-if="row1.item.splitFromId != '0'"
                  ><b-badge variant="info"
                    >Split of {{ row1.item.splitFromNo }}<br
                  /></b-badge>
                </h7>

                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  size="sm"
                  @click="
                    row1.item.is_locked == '1' &&
                    (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0)
                      ? LockUnLock(row1.item, 'locked')
                      : ''
                  "
                  :variant="
                    row1.item.is_locked == '1' &&
                    (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0)
                      ? 'danger'
                      : 'success'
                  "
                  ><b
                    v-if="
                      row1.item.is_locked == '1' &&
                      (row1.item.finalBillingCompleted == 1 ||
                        row1.item.locked_counter > 0)
                    "
                    ><i class="fa fa-lock mr-1 lg"></i>LOCKED</b
                  ><b v-else><i class="fa fa-unlock mr-1 lg"></i>UN-LOCKED</b></b-button
                ><br />
                <b-button
                  size="sm"
                  class="mt-2"
                  style="font-size: 0.675rem"
                  @click="showDocModal(row1.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
                <br />
                <Assignment-Summary
                  :title="'Shipment Summary Tracking - '"
                  :fk_all_module_id="row1.item.allModuleId"
                  :jb_series="row1.item.ccImportSeries"
                />
                <ContainerSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Container Summary Job No - ' + row1.item.ccImportSeries"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.ccImportSeries"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <!-- <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.ccImportSeries"
                  /> -->
                <RejectInvTallyBillSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="
                    'Invoice Rejection Log Summary Job No - ' + row1.item.ccImportSeries
                  "
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.ccImportSeries"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <MSDeleteRequest
                :item="row1.item"
                :JobNo="row1.item.ccImportSeries"
                :JobID="row1.item.allModuleId"
                :sessionsStorage="$sessionsStorage"
                @refreshData="handleRefresh"
              />
              <b v-if="row1.item.deleteRequestBy != '' && row1.item.deleteRequestBy != '0' && row1.item.deleteRequestBy != null">Requested By : {{ row1.item.deleteRequestBy }}<br/></b>
              <b v-if="row1.item.deleteArrovedBy != '' && row1.item.deleteArrovedBy != '0' && row1.item.deleteArrovedBy != null">Arroved By : {{ row1.item.deleteArrovedBy }}<br/></b>
              
              </template>
              <template slot="Exporter" slot-scope="row11">
                <b> {{ row11.item.Exporter }}</b>
              </template>
              <template slot="POR" slot-scope="row10">
                <span>Place of Receipt :- {{ row10.item.POR }}</span>
                <br />
                <span>Load Port :- {{ row10.item.LP }}</span>
                <br />
                <span>Port Of Discharge :- {{ row10.item.POD }}</span>
                <br />
                <span>Final Place of Delivery :- {{ row10.item.FPOD }}</span>
                <br />
                <span>Booking No. :- {{ row10.item.validBookingNo }}</span>
                <br />
              </template>

              <template slot="newContainer" slot-scope="row5">
                 <BookingTrack v-if="row5.item.newfreightContainers && row5.item.jobType.indexOf('FF')>=0" :containerArr="row5.item.newfreightContainers"
                :slineName="''"
                :clientName="row5.item.Exporter"
                :modal_title="`Container Movement Booking No: ${row5.item.validBookingNo} Job No - ${row5.item.ccImportSeries} Client: ${row5.item.Exporter}`"
                :JOBNO="row5.item.ccImportSeries" :shipment_id="Number(0)" :subscription_id="Number(0)" :fk_sub_track_id="Number(0)"
                :fk_all_module_id="Number(row5.item.allModuleId)" :fk_booking_id="Number(row5.item.fk_booking_id)"
                :fk_container_id="Number(0)" :booking_number="row5.item.validBookingNo" :container_number="''" />
                <div v-if="row5.item.newContainerFlow == '1'">
                  <div v-if="row5.item.newContainer">
                    <span
                      v-for="(item1, index) in row5.item.newContainer.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light">{{
                          item1 == "" ? "-------" : item1
                        }}</b-badge>
                      </h6>
                    </span>
                  </div>
                  <div class="text-left" v-else>
                    <b-badge variant="light">-------</b-badge>
                  </div>
                </div>
                <div v-else>
                  <div v-if="row5.item.oldContainer">
                    <span
                      v-for="(item1, index) in row5.item.oldContainer.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light">{{
                          item1 == "" ? "-------" : item1
                        }}</b-badge>
                      </h6>
                    </span>
                  </div>
                  <div class="text-left" v-else>
                    <b-badge variant="light">-------</b-badge>
                  </div>
                </div>
              </template>
              <!-- <template slot="newShipperInv" slot-scope="row50">
                <div v-if="row50.item.newContainerFlow == '1'">
                  <div v-if="row50.item.newShipperInv">
                    <span
                      v-for="(item1, index) in row50.item.newShipperInv.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light">{{
                          item1 == "" ? "-------" : item1
                        }}</b-badge>
                      </h6>
                    </span>
                  </div>
                  <div class="text-left" v-else>
                    <b-badge variant="light">-------</b-badge>
                  </div>
                </div>
                <div v-else>
                  <div v-if="row50.item.ShipperInvoiceNumber">
                    <span
                      v-for="(item1, index) in row50.item.ShipperInvoiceNumber.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light">{{
                          item1 == "" ? "-------" : item1
                        }}</b-badge>
                      </h6>
                    </span>
                  </div>
                  <div class="text-left" v-else>
                    <b-badge variant="light">-------</b-badge>
                  </div>
                </div>
               
              </template> -->
              <!-- <template slot="newSB" slot-scope="row500">
                <div v-if="row500.item.newContainerFlow == '1'">
                  <div v-if="row500.item.newSB">
                    <span
                      v-for="(item1, index) in row500.item.newSB.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light">{{
                          item1 == "" ? "-------" : item1
                        }}</b-badge>
                      </h6>
                    </span>
                  </div>
                  <div class="text-left" v-else>
                    <b-badge variant="light">-------</b-badge>
                  </div>
                </div>
                <div v-else>
                  <div v-if="row500.item.shippingBillNo">
                    <span
                      v-for="(item1, index) in row500.item.shippingBillNo.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light">{{
                          item1 == "" ? "-------" : item1
                        }}</b-badge>
                      </h6>
                    </span>
                  </div>
                  <div class="text-left" v-else>
                    <b-badge variant="light">-------</b-badge>
                  </div>
                </div>
              </template> -->
              <!-- <template slot="containerTypeData" slot-scope="row15">
                <div v-if="row15.item.containerTypeData != null">
                  <span
                    v-for="(item2, index) in row15.item.containerTypeData.split(
                      ','
                    )"
                    :key="index"
                  >
                    <h6>
                      <b-badge variant="light">{{ item2 }}</b-badge>
                    </h6>
                  </span>
                </div>
              </template> -->

              <!-- <template slot="billEntryDate" slot-scope="row2">
                   
              </template>-->
              <template slot="ffRailOutId" slot-scope="row3">
                <b
                  v-if="designation == 'superviser' && departmentName == 'Port/ICD'"
                  :style="
                    row3.item.ffRailOutId == null || row3.item.ffRailOutId == ''
                      ? { color: 'red' }
                      : { color: 'green' }
                  "
                  >{{
                    row3.item.ffRailOutId == "" || row3.item.ffRailOutId == null
                      ? "Pending"
                      : "Completed"
                  }}</b
                >
              </template>
              <template slot="invoiceStatus" slot-scope="row33">
                <b
                  :style="
                    row33.item.invoiceStatus == '0'
                      ? { color: 'green' }
                      : { color: 'red' }
                  "
                  >{{
                    !row33.item.invoiceStatus
                      ? "--"
                      : row33.item.invoiceStatus == "1"
                      ? "In-Progress"
                      : row33.item.invoiceStatus == "0"
                      ? "Sent To Accounts"
                      : "--"
                  }}</b
                >

                <b v-if="row33.item.sentForApproval && row33.item.sentForApproval == '1'">
                  <br />
                  Sent for Approval
                </b>
                <b
                  v-if="
                    row33.item.chnageApprovalStatus &&
                    row33.item.chnageApprovalStatus == '1'
                  "
                >
                  <br />
                  Was Sent for Approval and got Approved
                </b>
                <b
                  v-if="
                    row33.item.chnageApprovalStatus &&
                    row33.item.chnageApprovalStatus == '2'
                  "
                >
                  <br />
                  Was Sent for Approval and got Rejected
                </b>
              </template>

              <template slot="show_details" slot-scope="row">
                <b-form-checkbox
                  @change="row.toggleDetails"
                  v-model="row.detailsShowing"
                ></b-form-checkbox>
                <Add-Message
                  :fk_all_module_id="row.item.allModuleId"
                  :fk_client_id="row.item.clientId"
                  :fk_pod_id="row.item.PODLocationId"
                  style="list-style-type: none"
                />

                <Overseas-CRDRNote
                  v-if="row.item.jobType.indexOf('FF') < 0"
                  :title="row.item.ccImportSeries"
                  :moduleType="'CC ' + row.item.transportType + ' Module'"
                  :cr_all_module_id="row.item.allModuleId"
                  :cr_jb_series="row.item.ccImportSeries"
                  :cr_ass_date="row.item.dateAssignment | moment"
                  :transportType="row.item.transportType"
                  :Jobtype="'CC'"
                  :commonId="row.item.ccImportId"
                  :shipmentType="
                    row.item.shipmentType == '1' ||
                    row.item.shipmentType == 'Sea_Shipment'
                      ? 'Sea'
                      : 'Air'
                  "
                  :isOverseas="false"
                  :ItemAr="null"
                />
              </template>
              <template slot="row-details" slot-scope="row">
                <b-card>
                  <b-button
                    size="sm"
                    @click="goToDoc(row.item.ccImportId)"
                    variant="outline-info"
                    >View Documents</b-button
                  >
                  <br />
                  <b>
                    <u>Documentation Progress Summary</u>
                  </b>
                  <br />
                  <span
                    >Shipping Bill Date :
                    {{ row.item.shippingBillNo ? "Completed" : "Pending" }}</span
                  >
                  <br />
                  <span
                    >Leo Date : {{ !row.item.leoDate ? "Pending" : "Completed" }}</span
                  >
                  <br />
                  <span
                    >Handover Date :
                    {{ !row.item.handoverDate ? "Pending" : "Completed" }}</span
                  >
                </b-card>
              </template>
              <!-- <template slot="ccImportId" slot-scope="row9">
                <md-button @click="viewExportAirPage(row9.item)">
                  <a class="fa fa-pencil-square-o"></a>
                </md-button>
              </template>-->
            </b-table>
          </div>
          <div>
            <h5>
              <b-pagination
                limit="5"
                align="center"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
              ></b-pagination>
            </h5>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>

      <!-- Added By Priyanshu Singh For Billing Close Section Start -->
      <b-modal
        id="modal-lock-conf"
        ref="modal-lock-conf"
        title="Reason for Open Locked Assignment"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <h3>Confirmation</h3>
        <form ref="form">
          <b-form-group
            label="Remark"
            label-for="name-input"
            invalid-feedback="Name is required"
          >
            <b-form-textarea
              :formatter="capitalizeAll"
              rows="5"
              id="name-input"
              v-model="lockReason"
              required
            ></b-form-textarea>
          </b-form-group>
        </form>
        <b-button @click="closeLockUnLockConfirm" variant="danger"> Cancel</b-button>
        <b-button
          v-if="lockReason"
          :disabled="lock_button ? true : false"
          variant="success"
          class="pull-right"
          @click="ConfLock"
          >Send</b-button
        >
      </b-modal>
      <md-dialog-confirm
        :md-content-html="alert.content"
        :md-ok-text="alert.ok"
        ref="addPop"
      ></md-dialog-confirm>
      <!-- Added By Priyanshu Singh For Billing Close Section End -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AddMessage from "../../component/allModuleForm/addMessage.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import OverseasCRDRNote from "../common/overseasCRDRNote.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import MSDeleteRequest from "../common/MSDeleteRequest.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Custom Clearance")) {
      this.checkUserLoginTime();
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCExportDetail");

      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      lock_button: false,
      is_locked: "",
      locked_counter: "",

      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "2",
          int: "Sent to Accounts",
        },
        {
          inv: "3",
          int: "Billing Not Started",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      billingFilter: "",
      fields: [
        // "show_details",

        {
          key: "seenExec",
          mainkey: "seenExec",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "ccImportSeries",
          mainkey: "ccImportSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "Exporter",
          mainkey: "Exporter",
          label: "Client / Exporter Name",
          sortable: true,
          sortDirection: "ASC",
        },
        // {
        //   key: "Importer",
        //   mainkey: "clientName",
        //   label: "Importer Name",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "B."
        // },
        {
          key: "newContainer",
          mainkey: "newContainer",
          label: "Container No. // Shipping Bill No // Shipper Invoice No",
          sortable: true,
          sortDirection: "ASC",
        },
        // {
        //   key: "containerTypeData",
        //   mainkey: "containerTypeData",
        //   label: "Container Type",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
        // {
        //   key: "newSB",
        //   mainkey: "newSB",
        //   label: "Shipping Bill ",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
        // {
        //   key: "newShipperInv",
        //   mainkey: "newShipperInv",
        //   label: "Shipper Invoice ",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },

        {
          key: "POR",
          mainkey: "POR",
          label: "Other Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "invoiceStatus",
          mainkey: "invoiceStatus",
          label: "Invoice Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "show_details",
          mainkey: "billEntryDate",
          label: "More Details",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      pending_SB_Count: 0,
      pending_handover_Count: 0,
      pending_LEO_Count: 0,
      isLoading: false,
      filtrActive: 0,
      designation: "",
      departmentName: "",
      debounce: null,
      AirImportData: [],

      dateStatusFilter: "60",
      dateStatusList: [
        {
          inv: "60",
          int: "2 Month",
        },
        {
          inv: "90",
          int: "3 Month",
        },
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DocForm,
    ModelListSelect,
    AddMessage,
    AssignmentSummary,
    OverseasCRDRNote,
    ContainerSummary,
    AssignmentSplitMergeSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
    MSDeleteRequest,
    BookingTrack,
  },

  computed: {},

  methods: {
    checkUserLoginTime() {
      // Fetch the user's login time from your database or wherever you store it
      const userLoginTime = new Date(this.$sessionsStorage.get("cc_exp_job_pendency"));
      const currentTime = new Date();
      const compareTime = 3 * 60 * 60 * 1000;

      // Calculate the time difference in milliseconds
      const timeDifference = currentTime - userLoginTime;

      // If the time difference is greater than 3 hours (in milliseconds)
      // if (timeDifference > 3 * 60 * 60 * 1000) {
      if (timeDifference > compareTime) {
        // Redirect the user to another page using Vue Router
        this.$router.push("/ccExpPendency");
      }
    },
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "cc_export",
          update_key: "ccImportId",
          Title: tit,
          module_type: "CC Export",
        };
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.viewFFExportFCL("0", "0", "1", "1");
              this.lock_button = false;
              this.isLoading = false;
            }
            (this.lockReason = ""), this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => {});
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.allModuleId;
      this.lock_ffExportFclId = items.ccImportId;
      this.lock_ffExportFclSeries = items.ccImportSeries;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewFFExportFCL("0", "0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.ccImportSeries;
      console.log(this.ALLMODULE);

      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL("0", CURRENT, "2", event);
    },
    goToDoc(ID) {
      this.$router.push({
        path: "/CCImport/ccDocListPage/" + ID + "/Export",
      });
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(0, CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    goToMain() {
      this.$sessionsStorage.set("editCcImportId", "");
      this.$router.push({
        path: "/ccImport/CCExportEntry",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportAirPage(item) {
      let SEEN = item.seenExec;
      let AIR = item.ccImportId;
      this.$sessionsStorage.set("editCcImportId", AIR);
      this.$sessionsStorage.set("editCcType", "Export");

      if (SEEN != "1") {
        let paylod = {
          UpdateNotSeenToSeen: "yes",
          ccImportId: AIR,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/updateExecutionToSeenAllModules.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
            }
          })
          .catch((error) => {});
      }

      if (this.designation == "superviser" && this.departmentName == "Port/ICD") {
        this.$router.push({
          path: "/ccImport/ccHandoverToRail",
        });
      } else if (item.newContainerFlow == "1") {
        this.$router.push({
          path: "/ccImport/newCCExportEntry",
        });
      } else {
        this.$router.push({
          path: "/ccImport/CCExportEntry",
        });
      }
    },
    handleRefresh() {
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    viewFFExportFCL(filterIdD, CURRENT, SEARCH, pageNumber) {
      this.filtrActive = filterIdD;
      //this.AirImportData = [];
      this.isLoading = true;

      let payload = {
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        view: "view",
        DCfilterId: filterIdD,
        billingFilter: this.billingFilter,
        dateStatusFilter: this.dateStatusFilter,
        optTypeTransport: this.$sessionsStorage.get("optTypeTransport")
          ? this.$sessionsStorage.get("optTypeTransport")
          : "",
        optAllModuleIdTransport: this.$sessionsStorage.get("optAllModuleIdTransport")
          ? this.$sessionsStorage
              .get("optAllModuleIdTransport")
              .replace(/^,/, "")
              .replace(/,$/, "")
          : "",
      };
      console.log("sasas", payload);

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/viewCCExportList_NewV3_VP.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          console.log(data);
          if (status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }

            if (data.SeaConImportDetails.length > 0) {
              this.AirImportData = data.SeaConImportDetails;
            } else {
              this.AirImportData = [];
            }

            if (data.UserDetail.length > 0) {
              this.designation = data.UserDetail[0].designation;
              if (this.designation == "superviser") {
                this.fields.push({
                  key: "ffRailOutId",
                  mainkey: "ffRailOutId",
                  label: "Port Status",
                  sortable: true,
                  sortDirection: "ASC",
                });
              }

              let filter1 = data.UserDetail[0].departmentName1.split(",").filter((x) => {
                return x == "Port/ICD";
              });

              this.departmentName = filter1.length > 0 ? "Port/ICD" : "fdsf";
            }

            //  this.JqueryFun();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}
.form-group {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// viewCCExportDetail.vue?60808099